import NoSsr from "@mui/material/NoSsr";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useItemTooltip, useMouseTracker } from "@mui/x-charts/ChartsTooltip";
import { generateVirtualElement } from "../../../ResuableChartTooltip/generateVirtualElement";

// Shows a bar's value in a tooltip that follows the cursor on hover,
// instead of a value permanently drawn on the chart. This codebase never
// uses @mui/x-charts's own default ChartsTooltip (every chart wires a
// custom one via these same hooks - see src/components/ResuableChartTooltip)
// so this mirrors that established pattern rather than relying on the
// built-in one.
export default function BarItemTooltip() {
  const tooltipData = useItemTooltip();
  const mousePosition = useMouseTracker();

  if (!tooltipData || !mousePosition) {
    return null;
  }

  const isMousePointer = mousePosition.pointerType === "mouse";

  return (
    <NoSsr>
      <Popper
        sx={{ pointerEvents: "none", zIndex: (theme) => theme.zIndex.modal }}
        open
        placement={isMousePointer ? "top" : "bottom"}
        anchorEl={generateVirtualElement(mousePosition)}
      >
        <Paper elevation={2} sx={{ px: 1.5, py: 0.75, m: 1 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{tooltipData.formattedValue}</Typography>
        </Paper>
      </Popper>
    </NoSsr>
  );
}
